import reducer from './reducer';
import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise-middleware';
import logger from 'redux-logger';

export default createStore(reducer, applyMiddleware(promise,logger));